// extracted by mini-css-extract-plugin
export default {"container":"vYCt1VaxY9uYeYEDo2oS"};